<template>
  <div class="ikea_home">
    <transition name="fade" mode="out-in">
      <div class="selectorMask" v-if="showLotsSelector"></div>
    </transition>
    <loading v-if="loading" />
    <error />
    <!-- 虛擬繳費機_01設定車牌 -->
    <section>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 ikea-title text-center">線上停車查詢系統</div>
        </div>
        <div class="row">
          <div class="col-lg-12 lot-selector" v-on:click="showOtherLots()">
            <div class="ikea-box-pay">
              <div class="fl">
                {{ lots[currentLotIndex].name }}
              </div>
              <div class="fr">
                <i class="fas fa-chevron-down" v-if="!showLotsSelector"></i>
                <i class="fas fa-chevron-up" v-if="showLotsSelector"></i>
              </div>
              <div class="cb"></div>
            </div>
          </div>
          <transition name="fade" mode="out-in">
            <div v-if="showLotsSelector" class="col-lg-12 lot-selector">
              <div
                v-for="(lot, index) in lots"
                :key="lot.id"
                class="ikea-box-pay"
                v-on:click="changeLot(index)"
              >
                <div class="fl">{{ lot.name }}</div>
                <div class="fr">
                  <i class="fas fa-angle-right"></i>
                </div>
                <div class="cb"></div>
              </div>
            </div>
          </transition>

          <div class="col-lg-12" v-if="pay == true">
            <a v-on:click="webaps()">
              <div class="ikea-box-pay">
                <div class="fl">停車繳費</div>
                <div class="fr">
                  <i class="fas fa-angle-right"></i>
                </div>
                <div class="cb"></div>
              </div>
            </a>
          </div>

          <div class="col-lg-12" v-if="pay == false">
            <router-link to="/location">
              <div class="ikea-box-pay">
                <div class="fl">查詢停放位置</div>
                <div class="fr">
                  <i class="fas fa-angle-right"></i>
                </div>
                <div class="cb"></div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-12">
            <a v-on:click="naviagtion()">
              <div class="ikea-box-pay">
                <div class="fl">導航至汽車停車場入口</div>
                <div class="fr">
                  <i class="fas fa-angle-right"></i>
                </div>
                <div class="cb"></div>
              </div>
            </a>
          </div>

          <div class="col-lg-12" v-on:click="showMoreRemain()">
            <div class="ikea-box-pay">
              <div class="fl">
                剩餘車位
                <i class="fas fa-chevron-down" v-if="!moreRemain && emptyLotsAmounts.length > 1"></i>
                <i class="fas fa-chevron-up" v-if="moreRemain && emptyLotsAmounts.length > 1"></i>
              </div>
              <transition name="fade" mode="out-in">
                <div
                  class="ikea-number-emptylot fr"
                  v-if="emptyLotsAmounts.length != 0"
                >
                  {{ totalRemain }}
                </div>
                <div
                  class="ikea-number-emptylot fr"
                  v-if="emptyLotsAmounts.length == 0"
                >
                  <div class="lds-dual-ring"></div>
                </div>
              </transition>
              <div class="cb"></div>
            </div>
          </div>
          <div
            class="col-lg-12"
            v-for="emptyLotsAmount in emptyLotsAmounts"
            :key="emptyLotsAmount.name"
          >
            <div
              class="ikea-box-lot"
              v-if="moreRemain && emptyLotsAmount.name != '汽車區' && emptyLotsAmount.name != '總車位數'"
            >
              <div class="fl">{{ emptyLotsAmount.name }}</div>
              <transition name="fade" mode="out-in">
                <div class="ikea-number-emptylot fr">
                  {{ emptyLotsAmount.remain }}
                </div>
              </transition>
              <div class="cb"></div>
            </div>
          </div>

          <div class="col-lg-12 ikea-box-useway" v-if="pay == true">
            <!--<div class="ikea-text-useway">使用說明</div>-->
            <div class="ikea-content-payway">
              <ul>
                <li>大潤發店內之消費發票可折抵您的停車費用。</li>
                <li>可能需要您開啟相機授權，才能使用發票掃描折抵功能。</li>
                <li>
                  電子發票目前支援『捐贈發票』、『手機條碼載具』及『自然人憑證載具』設定。
                </li>
                <li>若需開立『統一編號』發票，請至線下繳費機操作。</li>
                <li>目前系統僅支援 LINE Pay 、 Apple Pay 支付。</li>
              </ul>
            </div>
          </div>

          <!--
                <div class="col-lg-12 ikea-box-payway">
                <div class="ikea-text-payway">支付方式</div>
                <div class="ikea-content-payway">
                  <ul>
                    <li></li>
                    
                    <li>目前系統僅支援 LINE Pay 支付。</li>
                  </ul>
                </div>
              </div>
          -->
        </div>
      </div>
      <div v-if="pay == true" class="ikea-hint">
        目前系統僅支援 LINE Pay、Apple Pay 支付
      </div>

      <div
        class="plate-modal modal fade"
        id="scan-error-modal"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div
              class="close-modal"
              data-dismiss="modal"
              v-on:click="keepScan()"
            >
              <div class="lr">
                <div class="rl"></div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-lg-8 mx-auto">
                  <div class="modal-body">
                    <!-- Project Details Go Here -->
                    <br />
                    <h3>您的瀏覽器不支援掃描</h3>
                    <transition name="fade" mode="out-in">
                      <p
                        key="1"
                        class="item-intro text-muted"
                        v-if="!showCopySuccess"
                      >
                        <span v-if="safari">
                          若需使用發票折抵功能，請
                          <br />1. 使用 Safari 瀏覽器 <br />2.
                          允許我們使用您的相機 <br />如果您不是使用 Safari
                          瀏覽器，可以點選『複製連結』至 Safari 瀏覽器。
                          <br />
                          <br />若您不需使用發票折抵，則無須理會此訊息。
                        </span>
                        <span v-if="android">
                          若需使用發票折抵功能，請
                          <br />1. 使用 Chrome 瀏覽器 <br />2.
                          允許我們使用您的相機 <br />如果您不是使用 Chrome
                          瀏覽器，可以點選『複製連結』至 Chrome 瀏覽器。
                          <br />
                          <br />若您不需使用發票折抵，則無須理會此訊息。
                        </span>
                      </p>
                      <div
                        key="2"
                        class="item-intro text-muted"
                        v-if="showCopySuccess"
                      >
                        <p>複製成功！</p>
                        <div class="col-lg-12 tips-iphone" v-if="safari">
                          <p>
                            請至
                            <span>【Sarfari 瀏覽器】</span
                            >將連結貼上網址列開啟網頁。
                          </p>
                        </div>
                        <!-- ios 顯示以上 -->

                        <!-- android 顯示以下 -->
                        <div class="col-lg-12 tips-android" v-if="android">
                          <p>
                            請至
                            <span>【Chrome 瀏覽器】</span
                            >將連結貼上網址列開啟網頁。
                          </p>
                        </div>
                        <!-- android 顯示以上 -->
                      </div>
                    </transition>
                    <button
                      class="btn btn-primary btn-frame"
                      data-dismiss="modal"
                      type="button"
                      v-on:click="keepScan()"
                    >
                      不使用發票掃描，繼續繳費
                    </button>
                    <button
                      class="btn btn-primary btn-green"
                      id="copyLink"
                      type="button"
                      data-clipboard-text="https://parking.rt-mart.com.tw/"
                    >
                      複製連結至其他瀏覽器
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- modal-content ends -->
        </div>
        <!-- modal-dialog ends -->
      </div>
      <!-- plate-delete-modal ends -->
    </section>
    <qrcode-stream
      class="qrcode"
      v-if="testScanner"
      @init="onInit"
      style="width: 0%; height: 0%"
    ></qrcode-stream>
  </div>
</template>

<style>
.selectorMask {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(100, 100, 100, 0.5);
  z-index: 5;
  right: 0;
  top: 0;
}
.lot-selector {
  z-index: 10;
}
</style>

<script>
import ClipboardJS from "clipboard";
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  name: "SettingPlate",
  props: {
    msg: String,
  },
  components: {
    QrcodeStream,
  },
  data() {
    return {
      loading: false,
      emptyLotsAmounts: [],
      totalRemain: 0,
      testScanner: false,
      showCopySuccess: false,
      safari: false,
      android: false,
      moreRemain: false,
      showLotsSelector: false,
      pay: true,
      currentLotIndex: 1,
      lots: [
        {
          id: "RT02001",
          name: "台北內湖 1 戶外",
          location: {
            lat: "25.060812",
            lng: "121.576562"
          }
        },
        {
          id: "RT02002",
          name: "台北內湖 2",
          location: {
            lat: "25.0623593",
            lng: "121.5744663"
          }
        },
        {
          id: "RT32001",
          name: "中壢",
          location: {
            lat: "24.954937",
            lng: "121.234062"
          }
        },
        // {
        //   id: "RT40401",
        //   name: "忠明",
        // },
      ],
    };
  },
  mounted() {
    var clipboard = new ClipboardJS(".btn");
    var self = this;
    //self.loading = true
    clipboard.on("success", function (e) {
      self.showCopySuccess = true;
      self.$ga.event("ikea-home", "click", "複製連結繼續掃描");
    });
    self.getEmptyLots();
    const queryLotCode = self.$route.query.lot
    if (queryLotCode) {
      for (var i = 0; i < self.lots.length; i++) {
        if (self.lots[i].id === queryLotCode) {
          self.currentLotIndex = i
        }
      }
    }
  },
  methods: {
    async onInit(promise) {
      var self = this;
      try {
        await promise;
        self.$router.push({ name: "webaps" , query: {lot: self.lots[this.currentLotIndex].id}});
        self.$ga.event("ikea-home", "click", "允許使用攝影機");
      } catch (error) {
        if (navigator.userAgent.indexOf("iPhone") >= 0) {
          self.android = false;
          self.safari = true;
        }
        if (navigator.userAgent.indexOf("Android") >= 0) {
          self.android = true;
          self.safari = false;
        }
        $("#scan-error-modal").modal("show");
      } finally {
        self.$root.loading = false;
        self.testScanner = false;
      }
    },
    getEmptyLots: function () {
      var self = this;
      self.$http
        .get(
          "https://" +
            process.env.VUE_APP_API_URL +
            "/lots/remain_region_space?brands=" +
            process.env.VUE_APP_BRAND +
            "&lot_code=" + self.lots[self.currentLotIndex].id
        )
        .then((response) => {
          for (var i = 0; i < response.body.length; i++) {
            if (response.body[i].name == "汽車區" || response.body[i].name == "總車位數" ) {
              self.totalRemain = response.body[i].remain;
            }
            if (response.body[i].remain < 0) {
              response.body[i].remain = 0;
            }
          }
          self.emptyLotsAmounts = response.body;
          self.loading = false;
        })
        .catch((err) => {
          self.loading = false;
        });
    },
    webaps: function () {
      var self = this;
      self.testScanner = true;
      self.$root.loading = true;
      this.$ga.event("ikea-home", "click", "停車繳費");
    },
    keepScan: function () {
      var self = this;
      self.$router.push({ name: "webaps" });
      self.$ga.event("ikea-home", "click", "不掃描直接繳費");
    },
    naviagtion: function () {
      var self = this;
      var win = window.open(
        `http://www.google.com/maps/place/${self.lots[self.currentLotIndex].location.lat},${self.lots[self.currentLotIndex].location.lng}`,
        "_blank"
      );
      self.$ga.event("ikea-home", "click", "導航至停車場");
      win.focus();
    },
    showMoreRemain: function () {
      var self = this;
      if (self.moreRemain) {
        self.moreRemain = false;
      } else {
        self.moreRemain = true;
      }
    },
    showOtherLots: function () {
      var self = this;
      if (self.showLotsSelector) {
        self.showLotsSelector = false;
      } else {
        self.showLotsSelector = true;
      }
    },
    changeLot: function (index) {
      var self = this;
      self.currentLotIndex = index;
      self.showOtherLots();
      self.loading = true;
      self.getEmptyLots();
    },
  },
};
</script>